import React, { useState, useEffect, useContext } from "react";
import FormButtons from "../../../revampComponents/Molecule/Buttons/FormButtons";
import LoadingSpinner from "../../../revampComponents/Atom/Loading";
import RichTextEditor from "../../../revampComponents/RichTextEditor";
import { JS_TYPES, regexMethods } from "../../../reusable/common";
import { getCurrentEventId, scrollToError } from "../../../Utils/helpers";
import { CHAR_LIMITS, entityModule } from "../../EventInfo/config/constants";
import {
  DateTimePicker,
  RainbowThemeContainer,
} from "react-rainbow-components";
import TagsComponent from "../../../revampComponents/Atom/Tags/TagsComponent";
import TwoLabelSwitch from "../../../revampComponents/Atom/TwoLabelSwitch";
import Checkbox from "../../../revampComponents/Atom/Input/Checkbox";
import DropdownWithIcon from "./DropdownWithIcon";
import IconDateTime from "../../../../src/revampComponents/Atom/Icons/IconDateTime.svg";
import { uploadFile } from "../../../revampCRUD/uploads.crud";
import { getEventEntity } from "../../../revampCRUD/EventEntity.curd";
import { getCategoryEntity } from "../../../revampCRUD/categoryEntity.curd";
import { CATEGORY_TYPES, categoryEntity, convertToDateObj, convertToEventTimeZone, ENTITY_MODULES, eventId, FIELD_NAMES, formatDateWithTimeZone, getOptionLabel, handleError, hardcodedTimeZone, mapEntities, mapToItemField, options, priorityOptions, SCREENS, stripHtmlTags, theme, TOGGLEMODE } from "./TaskManagementConstant";
import customToast from "../../../components/common/basic/Toast";
import UploadFiles from "./UploadFiles";
import { ErrMessages, SUCCESS_MESSAGES } from "../../EventInfo/config/error-constants";
import { useHistory, useParams } from "react-router-dom";
import Global from "../../../revampComponents/Atom/Global";
import CategoryDropdown from "./CategoryDropdown";
import { addCategoryEntity } from "../../../revampCRUD/taskCategory.crud";
import { DeleteModal } from "../../../revampComponents/Atom/Modals";
import ExhibitorsNCategoryExhibitorsTable from "./ExhibitorsNCategoryExhibitorsTable";

const AddNEditTask = ({ formik,
  addExhibitors = () => { },
  addCategories = () => { },
  removeExhibitor = () => { },
  removeCategory = () => { },
  updateExhibitorDeadline = () => { },
  updateCategoryDeadline = () => { },
  syncAllWithDefaults = () => { },
  updateExhibitorDeadlines = () => { },
  updateCategoryDeadlines = () => { },
  predefinedTaskDetails, isPredefinedTask, isEdit, setIsEdit, setTaskDetails, taskDetails, setEditCategoryIds, editCategorIds, exhibitorId, setParticularExhibitorTask, particularExhibitorTask, entityCategoryId, eventDetails, isExhibitorToggle, setIsExhibitorToggle }) => {
  const history = useHistory();
  const [exhibitorData, setExhibitorData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tagsData, setTagsData] = useState([]);
  const [value, setValue] = useState("");
  const [openSelectTicketDropdown, setOpenSelectTicketDropdown] = useState(false);
  const [isChecked, setIsChecked] = useState([]);
  const [filterTags, setFilterTags] = useState(exhibitorData);
  const [exhibitorTags, setExhibitorTags] = useState([]);
  const [exhibitorChecked, setExhibitorChecked] = useState([]);
  const [categoryTags, setCategoryTags] = useState([]);
  const [categoryChecked, setCategoryChecked] = useState([]);

  const [toggleState, setToggleState] = useState({
    toggleMode: TOGGLEMODE.EXHIBITOR,
  });

  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  const categoryType = CATEGORY_TYPES?.TASK;
  const eventID = eventDetails?.event_id;

  const [exhibitorWithEntity, setExhibitorWithEntity] = useState([]);
  const [showDateChangeWarning, setShowDateChangeWarning] = useState(false);
  const [pendingDateChange, setPendingDateChange] = useState(null);

  const eventEntityFunction = async (id) => {
    try {
      const result = await getEventEntity(id, entityModule.EXHIBITOR);
      if (result) {
        const allEntities = mapEntities(result?.data?.categorized, result?.data?.uncategorized);
        setExhibitorData(allEntities);
        setExhibitorWithEntity(result?.data?.categorized);

      }
    } catch (err) {
      handleError(err);
    }
  };
  const eventCategoryFunction = async (id) => {
    try {
      const result = await getCategoryEntity(id, categoryEntity.EXHIBITOR);
      if (result) {
        setCategoryData(result.data);
      }
    } catch (err) {
      handleError(err);
    }
  };

  const updateContent = (description) => {
    formik.setFieldValue("description", description)
  };

  const updateAssigneeToggle = (key, value) => {

    setToggleState((prevState) => {
      const newState = { ...prevState, [key]: value };

      if (value === TOGGLEMODE.CATEGORY) {

        setExhibitorTags(tagsData);
        setExhibitorChecked(isChecked);

        // In edit mode: Clear exhibitor items (keep _original for delete detection)
        if (isEdit && formik.values.exhibitors?.items?.length > 0) {
           formik.setFieldValue('exhibitors', {
            items: [],
            _original: []
          })
        }

        setTagsData(categoryTags);
        setIsChecked(categoryChecked);
        setFilterTags(categoryData);

      } else {

        setCategoryTags(tagsData);
        setCategoryChecked(isChecked);

        //  In edit mode: Clear category items (keep _original for delete detection)
        if (isEdit && formik.values.categories?.items?.length > 0) {
          formik.setFieldValue('categories.items', []);
        }

        if (isEdit && formik.values.category_ids?.length > 0) {
          formik.setFieldValue('category_ids', []);
          formik.setFieldValue('exhibitors', {
            items: [],
            _original: []
          });
        }

        setTagsData(exhibitorTags);
        setIsChecked(exhibitorChecked);
        setFilterTags(exhibitorData);
      }

      return newState;
    });
  };

  const handleDropdownChange = (fieldName, option) => {
    formik.setFieldValue(fieldName, option.value);
  };

  const getUploadedFiles = async (files) => {
    setLoading(true);
    try {
      if (files && files.length > 0) {
        const needsUpload = files.some(file => typeof file !== JS_TYPES.OBJECT || !file.url);

        const uploadedFiles = await Promise.all(
          files.map(async (file) => {
            if (file && typeof file === JS_TYPES.OBJECT && file.url) {
              return file;
            } else {
              const uploadedUrl = await uploadFile(file, 20);
              return { file_name: file.name, url: uploadedUrl, file_type: file.type, file_size: file.size };
            }
          })
        );

        setLoading(false);
        formik.setFieldValue("files", [...uploadedFiles]);

        if (needsUpload) {
          customToast.success(SUCCESS_MESSAGES.FILE_MESSAGE);
        }
      }
    } catch (error) {
      customToast.error(ErrMessages.DEFAULT_ERROR_MESSAGE, error);
    }
  };


  useEffect(() => {
    eventEntityFunction(eventId);
    eventCategoryFunction(eventId);
  }, []);
  const handleAutoAssignChange = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      const autoAssignType = toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ? 1 : 2;
      formik.setFieldValue("auto_assign_type", autoAssignType);
    } else {
      formik.setFieldValue("auto_assign_type", null);
    }
  };


  useEffect(() => {
    if (isEdit) return;

    // Handle exhibitor auto-population
    if (exhibitorId && exhibitorData?.length > 0 && toggleState.toggleMode === TOGGLEMODE.EXHIBITOR) {
      const exhibitorIdsArray = Array.isArray(exhibitorId)
        ? exhibitorId.map(String)
        : [String(exhibitorId)];

      const matchingExhibitors = exhibitorData?.filter(item =>
        exhibitorIdsArray?.includes(String(item?.category_id))
      );

      if (matchingExhibitors?.length > 0) {
        const exhibitorsToAdd = matchingExhibitors?.map(exhibitor => ({
          id: exhibitor.category_id,
          entity_name: exhibitor?.category_name || exhibitor?.entity_name,
          due_date: formik?.values?.due_date || null,
          reminder_date: formik?.values?.reminder_date || null
        }));

        const currentItems = formik?.values?.exhibitors?.items || [];
        const currentIds = currentItems?.map(item => item?.id);

        const newItems = exhibitorsToAdd?.filter(item =>
          !currentIds.includes(item?.id)
        );

        if (newItems?.length > 0) {
          formik.setFieldValue('exhibitors.items', [...currentItems, ...newItems]);
        }
      }
    }

    // Handle category auto-population
    if (entityCategoryId && categoryData?.length > 0 && toggleState.toggleMode === TOGGLEMODE.CATEGORY) {
      const categoryIdsArray = Array.isArray(entityCategoryId)
        ? entityCategoryId?.map(String)
        : [String(entityCategoryId)];

      const matchingCategories = categoryData?.filter(item =>
        categoryIdsArray?.includes(String(item?.category_id))
      );

      if (matchingCategories?.length > 0) {
        const categoriesToAdd = matchingCategories?.map(category => ({
          id: category?.category_id,
          category_name: category?.category_name,
          due_date: formik?.values?.due_date || null,
          reminder_date: formik?.values?.reminder_date || null
        }));

        const currentItems = formik?.values?.categories?.items || [];
        const currentIds = currentItems?.map(item => item?.id);

        const newItems = categoriesToAdd?.filter(item =>
          !currentIds?.includes(item?.id)
        );

        if (newItems.length > 0) {
          formik.setFieldValue('categories.items', [...currentItems, ...newItems]);
        }
      }
    }
  }, [isEdit, exhibitorId, entityCategoryId, exhibitorData, categoryData, toggleState.toggleMode]);

  useEffect(() => {
    if (isPredefinedTask) {
      formik.setFieldValue("title", predefinedTaskDetails.module_name);
      formik.setFieldValue("task_type", predefinedTaskDetails.task_type);
    }
  }, [isPredefinedTask, predefinedTaskDetails, isEdit]);

  useEffect(() => {
    if (!isEdit) return;

    const transformCategoryData = (data, categoryIds) => {
      if (!data || !Array.isArray(data) || !categoryIds) return [];
      return data
        ?.filter(item => categoryIds.includes(String(item.category_id)))
        ?.map(({ category_id: id, category_name: name }) => ({ id, name }));
    };

    const getAllIds = (data) => {
      if (!data || !Array.isArray(data)) return [];
      return data?.map(({ id }) => id);
    };

    const getIdAndName = (data) => {
      if (!data || !Array.isArray(data)) return [];
      return data.map(({ id, entity_name: name }) => ({ id, name }));
    };

    // Access the items array from formik.values.exhibitors
    const editExhibitorData = formik?.values?.exhibitors?.items || [];
    const editCategoryData = formik?.values?.categories?.items || [];
    const category = transformCategoryData(categoryData, formik?.values?.category_ids || []);

    if (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR) {
      setFilterTags(exhibitorData || []);

      if (editExhibitorData?.length > 0) {
        if (exhibitorData?.length === editExhibitorData?.length) {
          setIsChecked([...getAllIds(editExhibitorData), 'all']);
          setTagsData(getIdAndName(editExhibitorData));
        } else {
          setIsChecked(getAllIds(editExhibitorData));
          setTagsData(getIdAndName(editExhibitorData));
        }
      } else {
        setIsChecked([]);
        setTagsData([]);
      }

    } else {
      setFilterTags(categoryData || []);

      if (editCategoryData?.length > 0) {
        const categoryFormatted = editCategoryData?.map(({ id, category_name: name }) => ({ id, name }));

        if (categoryData?.length === editCategoryData?.length) {
          setIsChecked([...getAllIds(editCategoryData), 'all']);
          setTagsData(categoryFormatted);
        } else {
          setIsChecked(getAllIds(editCategoryData));
          setTagsData(categoryFormatted);
        }
      } else {
        setIsChecked([]);
        setTagsData([]);
      }
    }
  }, [isEdit, exhibitorData, categoryData, formik?.values?.exhibitors?.items, formik?.values?.categories?.items, toggleState.toggleMode]);

  // In AddNEditTask.js - Map category_ids to actual category objects
  useEffect(() => {
    if (isEdit && formik.values.category_ids?.length > 0 && categoryData?.length > 0) {
      const currentCategoryItems = formik.values.categories?.items || [];
      // Only map if not already mapped
      if (currentCategoryItems?.length === 0) {
        const categoryItems = formik?.values?.category_ids
          ?.map(catId => {
            const category = categoryData?.find(
              cat => cat?.category_id?.toString() === catId?.toString()
            );

            if (category) {
              return {
                id: category?.category_id,
                category_name: category?.category_name,
                due_date: formik.values?.due_date || null,
                reminder_date: formik?.values?.reminder_date || null
              };
            }
            return null;
          })
          .filter(Boolean);
        formik.setFieldValue('categories.items', categoryItems);
        formik.setFieldValue('categories._original', JSON.parse(JSON.stringify(categoryItems)));
      }
    }
  }, [isEdit, formik.values.category_ids, categoryData]);

  useEffect(() => {
    if (!categoryData?.length || !exhibitorData?.length) return;

    if (formik?.values?.category_ids && formik?.values?.category_ids?.length > 0) {
      setToggleState({ toggleMode: TOGGLEMODE?.CATEGORY });
      setIsExhibitorToggle(false);
    } else if (formik.values.exhibitors?.items?.length > 0) {
      setToggleState({ toggleMode: TOGGLEMODE?.EXHIBITOR });
      setIsExhibitorToggle(true);
    }
  }, [
    formik.values.category_ids?.length,
    formik.values.exhibitors?.items?.length,
    categoryData?.length,
    exhibitorData?.length
  ]);
  // Map category_ids with dates from exhibitors
  //This will now find exhibitors by category_id
  useEffect(() => {
    if (!isEdit) return;
    if (!formik?.values?.category_ids?.length) return;
    if (!categoryData?.length) return;

    const currentCategoryItems = formik?.values?.categories?.items || [];

    if (currentCategoryItems?.length === 0) {

      const categoryItems = formik?.values?.category_ids
        ?.map(catId => {
          const category = categoryData?.find(
            cat => cat?.category_id?.toString() === catId?.toString()
          );

          if (!category) {
            return null;
          }

          // Find exhibitors in this category (will now work because category_id exists!)
          const exhibitorsInCategory = (formik?.values?.exhibitors?.items || [])?.filter(
            exh => exh?.category_id?.toString() === catId?.toString()
          );

          let due_date = null;
          let reminder_date = null;

          if (exhibitorsInCategory?.length > 0) {
            const firstExhibitor = exhibitorsInCategory[0];
            due_date = firstExhibitor?.due_date;
            reminder_date = firstExhibitor?.reminder_date;
          } else {
            // Fallback to defaults
            due_date = formik?.values?.default_due_date;
            reminder_date = formik?.values?.default_reminder_date;

          }

          return {
            id: category?.category_id,
            category_name: category?.category_name,
            due_date: due_date,
            reminder_date: reminder_date
          };
        })
        .filter(Boolean);

      if (categoryItems.length > 0) {
        formik.setFieldValue('categories.items', categoryItems);
        formik.setFieldValue('categories._original', JSON.parse(JSON.stringify(categoryItems)));
      }
    }
  }, [isEdit, formik.values.category_ids, categoryData]);


  // Check if there are any individual assignments
  const hasIndividualAssignments = () => {
    const currentSelectedData = toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ?
      (formik.values.exhibitors?.items || []) : (formik.values.categories?.items || []);

    return currentSelectedData.length > 0;
  };



  const updateAllIndividualDeadlines = (dateType, newValue) => {
    const itemField = mapToItemField(dateType);

    if (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR) {
      const items = formik?.values?.exhibitors?.items || [];
      const updated = items?.map(item => ({
        ...item,
        [itemField]: newValue,
      }));
      formik.setFieldValue('exhibitors.items', updated);
    } else {
      const items = formik?.values?.categories?.items || [];
      const updated = items?.map(item => ({
        ...item,
        [itemField]: newValue,
      }));
      formik.setFieldValue('categories.items', updated);
    }
  };

  // Also add safety checks to handleDateChange:
  const handleDateChange = (value, fieldName) => {

    // Check if we need to show warning modal
    if (hasIndividualAssignments()) {
      setPendingDateChange({
        dateType: fieldName,
        newValue: value,
        oldValue: formik.values[fieldName]
      });
      setShowDateChangeWarning(true);
      return; // Don't update formik yet, wait for user confirmation
    }

    // No assignments exist, directly update formik
    formik.setFieldValue(fieldName, value);
  };

  // Handle warning modal confirmation
  const handleDateChangeConfirmation = (updateIndividual = false) => {
    if (pendingDateChange) {
      // Apply the formik change
      formik.setFieldValue(pendingDateChange?.dateType, pendingDateChange?.newValue);

      // Update individual deadlines if user chose to update all
      if (updateIndividual) {
        updateAllIndividualDeadlines(pendingDateChange?.dateType, pendingDateChange?.newValue);
      }
    }

    setShowDateChangeWarning(false);
    setPendingDateChange(null);
  };

  // Handle warning modal cancellation
  const handleDateChangeCancel = () => {
    if (pendingDateChange) {
      // Update only default field
      formik.setFieldValue(pendingDateChange?.dateType, pendingDateChange?.newValue);
    }
    // Do not touch exhibitors/categories
    setShowDateChangeWarning(false);
    setPendingDateChange(null);
    // The formik value remains unchanged, which is what we want
  };


  // Get modal text
  const getModalText = () => {
    if (!pendingDateChange) return '';
    const isReminderDate = pendingDateChange?.dateType === 'default_reminder_date';
    const dateType = isReminderDate ? 'Reminder Date' : 'Due Date';
    const entityType = toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? "Exhibitors" : "Categories";

    return `<b>Update ${dateType} for ${entityType}</b><br />Do you want to update the ${dateType} for all ${entityType.toLowerCase()} with the new default?`;
  };
  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      const response = await getCategoryEntity(eventID, categoryType);
      const sortedCategories = (response?.data || [])?.sort((a, b) =>
        a?.category_order - b?.category_order
      );
      setCategories(sortedCategories);
    } catch (error) {
      customToast.error(error?.response?.data?.message || 'Failed to fetch categories');
    } finally {
      setLoadingCategories(false);
    }
  };

  useEffect(() => {
    if (eventID) {
      fetchCategories();
    }
  }, [eventID]);

  const handleCreateNewCategory = async (values) => {
    try {
      const payload = {
        category_name: values?.category_name,
        category_type: categoryType,
        category_order: categories?.length + 1
      };

      const response = await addCategoryEntity(eventID, payload);

      const newCategory = {
        category_id: response?.data?.category_id,
        category_name: values?.category_name,
        category_order: payload?.category_order
      };

      // Add to categories list
      setCategories(prev => [...prev, newCategory]?.sort((a, b) =>
        a?.category_order - b?.category_order
      ));

      customToast.success('Category created successfully!');
      return newCategory;
    } catch (error) {
      customToast.error(error?.response?.data?.message || 'Failed to create category');
    }
  };

  const handleCategoryChange = (option) => {
    formik.setFieldValue('task_category_id', option?.value || '');
  };

  const getSelectedCategoryOption = () => {
    if (!formik?.values?.task_category_id) return null;

    const category = categories?.find(cat =>
      cat?.category_id?.toString() === formik?.values?.task_category_id?.toString()
    );

    if (category) {
      return {
        value: category?.category_id,
        label: category?.category_name,
        data: category
      };
    }
    return null;
  };

  useEffect(() => {
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  
  return (
    <>
      {formik.values && Object.keys(formik.values).length !== 0 ? (
        <div className="px-4 pt-2">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-12 col-md-12 pt-1">
                <div>
                  <label htmlFor="task_title" className="label task-input-label mt-2">
                    Task Title <span className="text-danger"> *</span>
                  </label>
                </div>
                <div>
                  <input
                    id="title"
                    name="title"
                    placeholder="Enter task title"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title}
                    disabled={isPredefinedTask}
                    className={
                      formik.errors.title && formik.touched.title
                        ? "input border-danger box-shawdow-none"
                        : "input task-input-label"
                    }
                  />
                  {formik.errors.title && formik.touched.title && (
                    <p className="text-danger mt-2">{formik.errors.title}</p>
                  )}
                </div>
              </div>

              <div className="col-12 col-md-4 pt-1 mt-2">
                <div>
                  <label htmlFor="task_type" className="label mt-2">
                    Task Type <span className="text-danger"> *</span>
                  </label>
                </div>
                <div>
                  <DropdownWithIcon
                    value={options.find(
                      (option) => option.value === formik.values.task_type,
                    )}
                    options={options}
                    onChange={(option) =>
                      handleDropdownChange("task_type", option)
                    }
                    onBlur={() => formik.setFieldTouched("task_type", true)}
                    getOptionLabel={getOptionLabel}
                    disabled={isPredefinedTask || isEdit}
                    className={`task-dropdown ${isPredefinedTask || isEdit ? "task-dropdown-disabled" : ""}`}
                  />
                  {formik.errors.task_type && formik.touched.task_type && (
                    <p className="text-danger mt-2">{formik.errors.task_type}</p>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-4 pt-1 mt-2">
                <div>
                  <label htmlFor="priority" className="label mt-2">
                    Priority
                  </label>
                </div>
                <div>
                  <DropdownWithIcon
                    value={priorityOptions.find(
                      (option) => option.value === formik.values.priority,
                    )}
                    options={priorityOptions}
                    onChange={(option) =>
                      handleDropdownChange("priority", option)
                    }
                    onBlur={() => formik.setFieldTouched("priority", true)}
                    getOptionLabel={getOptionLabel}
                  />

                  {formik.errors.priority && formik.touched.priority && (
                    <p className="text-danger mt-2">{formik.errors.priority}</p>
                  )}
                </div>
              </div>
              <div className="col-md-4 pt-1 mt-2">
                <label className="label  mt-2">
                  Category
                </label>
                <CategoryDropdown
                  value={getSelectedCategoryOption()}
                  onChange={handleCategoryChange}
                  onBlur={() => formik?.setFieldTouched('task_category_id', true)}
                  categories={categories}
                  onCreateNewCategory={handleCreateNewCategory}
                  loading={loadingCategories}
                  error={formik?.errors?.task_category_id}
                  touched={formik?.touched?.task_category_id}
                />
              </div>
              <div className="col-12 col-md-12 pt-1 mt-2">
                <div>
                  <label htmlFor="description" className="label mt-2">
                    Task Description
                  </label>
                </div>
                <div>

                  <RichTextEditor
                    value={formik.values.description}
                    onChange={updateContent}
                    placeholder="Enter your description here"
                    preset="extended"
                  />
                  <div className="d-flex justify-content-between">
                    <p className="text-danger mt-2 pt-1 mb-0">
                      {formik.errors.description &&
                        formik.touched.description && (
                          <p>{formik.errors.description}</p>
                        )}
                    </p>
                    <p className="maxCharForInput">
                      Maximum Characters: {CHAR_LIMITS.taskDescription.descMax}
                    </p>
                  </div>
                </div>
              </div>
              <UploadFiles isEdit={isEdit} formik={formik} getUploadedFiles={getUploadedFiles} loading={loading} />
              <div className="d-flex mt-2 align-items-start justify-content-between col-12 task-form-input-title  pt-1 task-time-container">
                <div
                  className="d-flex flex-column"
                  style={{ maxWidth: "640px" }}
                >
                  <p className="task-form-input-title">Default Reminder Date</p>
                  <p className="task-form-input-subtitle">
                    Set a default  reminder date for the task. A notification will be sent to exhibitors on this date. <br />
                    <strong>Note:</strong> Used as initial values for exhibitors. You can customize per exhibitor below.
                  </p>
                </div>
                <div>
                  <div className="text-right timezone-task-text"><Global timeZone={eventDetails?.time_zone} /></div>

                  <div className="dateTimeInput w-100">
                    <RainbowThemeContainer
                      theme={theme}
                      className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                    >
                      <DateTimePicker
                        id="default_reminder_date"
                        name="default_reminder_date"
                        locale="en-IN"
                        className={
                          formik.errors["default_reminder_date"] &&
                            formik.touched.default_reminder_date
                            ? "calendarCus border-danger box-shawdow-none "
                            : "calendarCus "
                        }
                        value={
                          convertToDateObj(formik.values?.default_reminder_date !== null ? formik.values?.default_reminder_date : '')
                        }
                        hideLabel={true}
                        okLabel="Save"
                        label="DateTimePicker label"
                        formatStyle="medium"
                        minDate={new Date()}
                        icon={<img src={IconDateTime} />}
                        onChange={(e) => handleDateChange(e, "default_reminder_date")}
                      />
                    </RainbowThemeContainer>
                    {formik.errors.default_reminder_date && (
                      <p className="text-danger mt-2">
                        {formik.errors.default_reminder_date}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex mt-2 align-items-start justify-content-between col-12 task-form-input-title task-time-container pt-1">
                <div
                  className="d-flex flex-column"
                  style={{ maxWidth: "610px" }}
                >
                  <p className="task-form-input-title">Default Due Date</p>
                  <p className="task-form-input-subtitle">
                    Set a default due date for the task. A reminder will be automatically sent to exhibitors 24 hours before the deadline. <br />
                    <strong>Note:</strong> Used as initial values for exhibitors. You can customize per exhibitor below.
                  </p>
                </div>
                <div>
                  <div className="text-right timezone-task-text"><Global timeZone={eventDetails?.time_zone} /></div>
                  <div className="dateTimeInput w-100">
                    <RainbowThemeContainer
                      theme={theme}
                      className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                    >
                      <DateTimePicker
                        id="default_due_date"
                        name="default_due_date"
                        locale="en-IN"
                        className={
                          formik.errors["default_due_date"] &&
                            formik.touched.default_due_date
                            ? "calendarCus border-danger box-shawdow-none "
                            : "calendarCus "
                        }
                        value={
                          convertToDateObj(formik.values?.default_due_date !== null ? formik.values?.default_due_date : '')
                        }
                        hideLabel={true}
                        okLabel="Save"
                        label="DateTimePicker label"
                        formatStyle="medium"
                        minDate={new Date()}
                        icon={<img src={IconDateTime} />}
                        onChange={(e) => handleDateChange(e, "default_due_date")}
                      />
                    </RainbowThemeContainer>
                    {formik.errors.default_due_date && (
                      <p className="text-danger mt-2">
                        {formik.errors.default_due_date}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 pt-1 mt-2">
                <div className="d-flex align-items-center">
                  <span className="label manual-label-text task-form-checkbox-title">
                    Assign to Exhibitors
                  </span>
                  <div className="">
                    <TwoLabelSwitch
                      value={toggleState.toggleMode === TOGGLEMODE.EXHIBITOR}
                      onChangeSwitch={(value) => {
                        const newMode = value
                          ? TOGGLEMODE.CATEGORY
                          : TOGGLEMODE.EXHIBITOR;
                        updateAssigneeToggle("toggleMode", newMode);
                      }}
                    />
                  </div>
                  <span className="label task-form-checkbox-title">Assign to Categories</span>
                </div>
                <ExhibitorsNCategoryExhibitorsTable
                  toggleLabel={toggleState.toggleMode}
                  toggleExhibitorTags={toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ? exhibitorTags : categoryTags}
                  exhibitorItems={formik?.values?.exhibitors.items}
                  categoryItems={formik?.values?.categories.items}
                  defaultDueDate={formik?.values?.default_due_date}
                  defaultReminderDate={formik?.values?.default_reminder_date}
                  // helper functions
                  onAddExhibitors={addExhibitors}
                  onAddCategories={addCategories}
                  onRemoveExhibitor={removeExhibitor}
                  onRemoveCategory={removeCategory}
                  onUpdateExhibitorDeadline={updateExhibitorDeadline}
                  onUpdateCategoryDeadline={updateCategoryDeadline}
                  onUpdateExhibitorDeadlines={updateExhibitorDeadlines}
                  onUpdateCategoryDeadlines={updateCategoryDeadlines}
                  onSyncAllWithDefaults={syncAllWithDefaults}
                  allExhibitor={exhibitorData}
                  allCategory={categoryData}
                  exhibitorWithEntity={exhibitorWithEntity}
                  isEdit={isEdit}

                />

                {/* Warning Modal for Default Date Changes */}
                {showDateChangeWarning && pendingDateChange && (
                  <DeleteModal
                    width={"450px"}
                    openModal={showDateChangeWarning}
                    setOpenModal={setShowDateChangeWarning}
                    primaryBtnContent={"Yes, update all"}
                    cancelBtnContent={"No, keep existing dates"}
                    item=""
                    // extraComponent={
                    //   <p className="mt-4 uploaded-images change-asset-type-cont">
                    //     <b>Note: </b>
                    //     <span className="change-asset-noteText">
                    //       This will update the {pendingDateChange?.dateType === 'reminder_date' ? 'reminder date' : 'due date'} for all assigned {toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ? "exhibitors" : "categories"} to the new default value.
                    //     </span>
                    //   </p>
                    // }
                    text={getModalText()}
                    onCancel={handleDateChangeCancel}
                    onOkay={() => handleDateChangeConfirmation(true)}
                  />
                )}
                <div></div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
              <div className="d-flex align-items-center">
                <div className="d-flex justify-content-center aligns-items-center">
                  <Checkbox
                    labelClassName="checkboxCard-label ml-1"
                    checked={formik.values.auto_assign_type === (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ? 1 : 2)}
                    onChange={handleAutoAssignChange}
                  />
                  <span className="label task-form-input-title pr-2">
                    {`Auto Assign to Future ${toggleState.toggleMode === TOGGLEMODE.EXHIBITOR
                      ? "Exhibitors"
                      : "Exhibitors of the Selected Categories"
                      }`}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-2 loadingCenter ">
              <FormButtons
                isLoading={loading || formik.isSubmitting}
                formik={formik}
                onSave={() => {
                  scrollToError(formik);
                  formik.submitForm();
                }}
                onCancel={() => {
                  formik.handleReset();
                  history.push(exhibitorId
                    ? `/e/${eventId}/exhibitor-portal/${exhibitorId}/tasks`
                    : `/e/${eventId}/exhibitor-portal/task-management`);
                }}
                saveBtnContent="Save"
                // cancelBtnDisabled={!formik.dirty}
                saveBtnDisabled={loading || !formik.dirty || formik.isSubmitting}
              />
            </div>
          </form>
        </div>
      ) : (
        <LoadingSpinner />
      )}
      <style>{`
		.task-upload-container {
			width: 100%;
		}
    .timezone-task-text{
     color: var(--primaryColor) !important;
     font-size:11px ;
    }
     .task-form-input-title{
           color: var(--primaryTextColor) !important;
           margin-bottom: 5px;
    }
     .task-form-checkbox-title{
           color: var(--primaryColor) !important;
    }
       .task-form-input-subtitle{
           color:#333333;
            font-size:14px;
            font-weight:400;
     }
     .checkboxCard-label{
          margin-top:5px;
     }
      .task-input-label:disabled, task-input-label {
        background-color: #F2F2F2 !important;
      }
      .task-time-container .dateTimeInput {
        min-width: 184px;
      }
	`}</style>
    </>
  );
};

export default AddNEditTask;
